import './Grid.scss'
import ReactCommunityCard from '../../ReactCommunityCard/ReactCommunityCard'
import { GridType } from '../../types'

const Grid = (props: GridType): JSX.Element => {
  const { items } = props

  return (
    <div className='grid-container'>
      <div className='grid-container__row'>
        {items.map((item: any, index: number) => (
          <div
            className='grid-container__column container-fluid col-lg-4 col-md-6 col-sm-12'
            key={`community-card-${index}`}
          >
            <ReactCommunityCard community={item} />
          </div>
        ))}
      </div>
    </div>
  )
}
export default Grid
